// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"b19c1a99","498":"9530588e","632":"906f6644","787":"9f2bcc1f","982":"07c51fbc"}[chunkId] + ".chunk.js";
};